import { StyleSheet, Text, View } from '@react-pdf/renderer'
import React from 'react'
import BreakText from '../../BreakText'
import Grid from '../../Grid'

interface OwnProps {
  questionName: string
}

const styles = StyleSheet.create({
  gridText: { width: '100%' },
  message: { color: '#656565', paddingLeft: 5, paddingTop: 5 },
})

export const NoMasterDataMessage: React.FC<OwnProps> = (props: OwnProps) => {
  return (
    <Grid borderLeft borderRight style={styles.gridText}>
      <View>
        <BreakText text={props.questionName} />
        <Text style={styles.message}>
          この製品では、管理者の設定により回答は不要です
        </Text>
      </View>
    </Grid>
  )
}
